import React, {useEffect, useState} from 'react'
import './styles.css'
import Header from '../../../components/Header/Header'
import {Col, Container, Row, Button} from "react-bootstrap";
import LeagueCard from "../../../components/LeagueCard/LeagueCard";
import {getRegistrationDetails, getPaymentData, getTournamentRegistrationDetails} from "../../../services/registrations";
import moment from 'moment';
import MBIcon from "../../../assets/images/mb_icon.svg";
import MBWayIcon from "../../../assets/images/mbway_icon.svg";
import ScaleLoader from "react-spinners/ScaleLoader";
import {NotificationManager} from "react-notifications";
import {useHistory, useLocation} from "react-router-dom";
import {Trans, useTranslation} from "react-i18next";

const override = `
    display: block;
    text-align: center;
    margin-top: 10%;
`;

const PaymentSummary = (props) => {
   const [registrationDetails, setRegistrationDetails] = useState({});
   const [paymentData, setPaymentData] = useState({});
   const [loading, setLoading] = useState(true);
   const [errorMessage, setErrorMessage] = useState("");
   const history = useHistory();
   const { t } = useTranslation();
   let queryString = useQuery();

   useEffect(() => {
      (async () => {
         let registrationDetails;
         let paymentData;

         try {
            paymentData = await getPaymentData(queryString.get("resourcePath"), props.match.params.registrationId, queryString.get("is_league"));
         } catch (e) {
            if (e.status === 400) {
               if (typeof e.data.mensagem !== 'undefined') {
                  setErrorMessage(e.data.mensagem);
               } else {
                  NotificationManager.error(t("common.form.errors.general_alt"), t("common.error"), 4000);
               }
            }
         }

         if (JSON.parse(queryString.get("is_league"))) {
            registrationDetails = await getRegistrationDetails(props.match.params.registrationId);
         } else {
            registrationDetails = await getTournamentRegistrationDetails(props.match.params.registrationId);
         }

         setRegistrationDetails(registrationDetails);
         setPaymentData(paymentData);
         setLoading(false);
      })()
   }, []);


   let isPaymentMB = registrationDetails.payment_method === "Pagamento por DPG" && registrationDetails.selected_payment === "SIBS_MULTIBANCO";
   let isPaymentMBWay = registrationDetails.payment_method === "Pagamento por DPG" && registrationDetails.selected_payment === "MBWAY";
   let isPaymentClubDay = registrationDetails.payment_method === "Pagamento no clube no dia do torneio";
   let isPaymentBankTransfer = registrationDetails.payment_method === "Pagamento por transferência bancária";
   let playersSummary = registrationDetails.second_player_name
      ? registrationDetails.first_player_name + " e " + registrationDetails.second_player_name
      : registrationDetails.first_player_name;

   return <div>
      <Header headerBarTitle={t("registration_page.header")} showHeaderExtras={true}/>
      <div className={"main"}>
         <ScaleLoader
            css={override}
            sizeUnit={"px"}
            size={30}
            color={'#afff55'}
            loading={loading}
         />
         {!loading &&
            <Container className={"desktop"}>
               <Row className="mt-5 mb-3">
                  <Col className={"text-center"}>
                     {!isPaymentClubDay && errorMessage === "" &&
                        <h2 className={"d-sm-block text-uppercase"}>
                           <Trans i18nKey="registration_page.payment_pending" components={{ br: <br /> }}/>
                        </h2>
                     }

                     {isPaymentMBWay && errorMessage !== "" &&
                        <h2 className={"d-sm-block text-uppercase"}>{t("registration_page.errors.mbway")}</h2>
                     }

                     {isPaymentClubDay &&
                        <h2 className={"d-sm-block text-uppercase"}>
                           <Trans i18nKey="registration_page.thank_you" components={{ br: <br /> }}/>
                        </h2>
                     }
                  </Col>
               </Row>
               <Row className={"mb-4"}>
                  <Col>
                     <LeagueCard leagueNameClasses="card-games pb-3 mb-3"
                                 leagueName={JSON.parse(queryString.get("is_league")) ? `${registrationDetails.league}, ${registrationDetails.league_edition}` : registrationDetails.tournament_name}
                                 leagueDate={JSON.parse(queryString.get("is_league")) ? registrationDetails.league_category : registrationDetails.category_name}>
                        <p className="start-date-container start-date-text">{playersSummary}</p>
                     </LeagueCard>
                  </Col>
               </Row>

               {isPaymentMBWay &&
                  <Row>
                     <Col className="d-flex flex-column justify-content-center">
                        <img src={MBWayIcon} className={"mbway-icon mb-3"} alt={"mbway icon"}/>
                        {errorMessage === ""
                           ? <p className={"registration-total bold text-center"}>{t("registration_page.open_mbway")}</p>
                           : <p className={"registration-total bold text-center"}>{errorMessage}</p>
                        }
                     </Col>
                  </Row>
               }

               {isPaymentMB &&
                  <Row>
                     <Col md={12} lg={12} xl={12} className={"d-flex align-items-center justify-content-center"}>
                        <img src={MBIcon} className={"mb-icon mr-3"} alt={"multibanco icon"}/>
                        <div>
                           <p className={"ml-2"}><strong>{t("registration_details_page.payment_mb_entity")} </strong>{registrationDetails.entity}</p>
                           <p className={"ml-2"}><strong>{t("registration_details_page.payment_mb_ref")} </strong>{registrationDetails.reference}</p>
                           <p className={"ml-2"}><strong>{t("registration_details_page.payment_mb_amount")} </strong>{registrationDetails.payment_amount} €</p>
                        </div>
                     </Col>
                     <Col md={12} lg={12} xl={12}>
                        <p className={"mt-5 payment-deadline-text info-color text-center"}>
                           {t("registration_details_page.payment_mb_chosen_details", {day: moment(registrationDetails.payment_deadline).utc(false).format("D [de] MMMM [de] YYYY")})}
                        </p>
                     </Col>
                  </Row>
               }

               {isPaymentBankTransfer &&
                  <Row>
                     <Col className={"d-flex flex-column align-items-center"}>
                        <div>
                           <p className={"ml-2"}><strong>{t("registration_details_page.payment_transfer_iban")} </strong>{registrationDetails.payment_note}</p>
                           <p className={"ml-2 mb-4"}>
                              <strong>{t("registration_details_page.payment_transfer_value")} </strong>{registrationDetails.payment_amount} €
                           </p>
                        </div>

                        <p className={"ml-2 payment-deadline-text info-color text-center"}>{t("registration_page.payment_transfer_note", { day: moment(registrationDetails.payment_deadline).utc(false).format("DD [de] MMMM [de] YYYY") })}</p>
                     </Col>
                  </Row>
               }

               {isPaymentClubDay &&
                  <Row>
                     <Col>
                        <p className={"ml-2 payment-deadline-text info-color text-center"}>{t("registration_page.payment_club_note")}</p>
                     </Col>
                  </Row>
               }

               <Row className={"btn-align-bottom"}>
                  <Container className={"desktop"}>
                     <Col>
                        {
                           isPaymentMBWay && errorMessage === "" &&
                           <p className={"email-info-message info-color text-center mb-4"}>{t("registration_page.registration_copy_note")}</p>
                        }
                        {
                           isPaymentMBWay && errorMessage !== "" &&
                           <Button onClick={() => history.push(`/enrollment/${props.match.params.registrationId}/payment`)}
                                   className={"btn-primary w-100 mb-3"}>{t("common.try_again")}</Button>
                        }
                        {
                           (isPaymentClubDay ||
                              isPaymentBankTransfer ||
                              isPaymentMB) &&

                           <p className={"email-info-message info-color text-center mb-4"}>{t("registration_page.payment_details_sent")}</p>
                        }
                        <Button onClick={() => history.push('/enrollment/list')}
                                className={"btn-secondary w-100"}>{t("common.close")}</Button>
                     </Col>
                  </Container>
               </Row>
            </Container>
         }

      </div>
   </div>
}

const useQuery = () => {
   const {search} = useLocation();
   return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default PaymentSummary;
